export function getAmountNumber(num){

    let newNum = num.toString() ==''? '0':num;

    return parseFloat(newNum).toFixed(2).toString();
}